import _ from 'lodash';
import { NAME } from './constants';

export const getParamsToken = state => _.get(state[NAME], 'paramsToken');
export const getAuthorizeToken = state => _.get(state[NAME], 'token');
export const getBaseExtension = state => _.get(state[NAME], 'authModel.server');
export const isAuthorizing = state => _.get(state[NAME], 'authorizing');